import api from '@/apis/dashboard/dashboardUsingIncomeAndExpenseAPI.js';
import Chart from '@/stores/baseChart.js';
const chart = new Chart('usingIncomeAndExpense', api);

const state = {
  ...chart.state,
  colors: ['#0eac13', '#ec6666'],
  categorieDatas: ['Số thu', 'Số chi'],
};
const getters = {
  ...chart.getters,
};
const actions = {
  ...chart.actions,
};
const mutations = {
  ...chart.mutations,
  /**
   * Set items
   * @param {*} state state
   * @param {*} data data
   * HTHIEP 21.06.2023
   */
   setItems(state, data) {
    let dataCustom = [];
    let colors = [];
    let categorieDatas = [];
    if(data && (data.Receipt != 0 || data.Expense != 0) )
    {
      
      let datas = [data.Receipt,data.Expense];
      datas = datas.filter(x => (x != null && x != undefined));
      dataCustom = [{data:datas}];
    }
    // gán dữ liệu load lên biểu đồ
    state.items = dataCustom;

    if(data.Receipt != null && data.Receipt != undefined)
    {
      colors.push('#0eac13');
      categorieDatas.push('Số thu');
    }

    if(data.Expense != null && data.Expense != undefined)
    {
      colors.push('#ec6666');
      categorieDatas.push('Số chi');
    }

    // gán color và categories
    state.colors = [...colors];
    state.categorieDatas =  [...categorieDatas];
  },
};

export default {
  // eslint-disable-next-line no-undef
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};